export const SEASON_IMG = {
  SPRING : `https://sphokidz.s3.ap-northeast-2.amazonaws.com/medium/common/139/qna_165708657154186.png`,  
  SUMMER : `https://sphokidz.s3.ap-northeast-2.amazonaws.com/medium/common/139/qna_1657086572709808.png`,
  AUTUMN : `https://sphokidz.s3.ap-northeast-2.amazonaws.com/medium/common/139/qna_1657086574242798.png`,
  WINTER : `https://sphokidz.s3.ap-northeast-2.amazonaws.com/medium/common/139/qna_1657086576781185.png`,
}